export default "__VITE_ASSET__Cqjud4Ip__"